module.exports = __webpack_public_path__ + "static/pigly03-sq-caf78232291fd729f2e81e9846e4668d.png";